import ProductList from './src/main';

/* istanbul ignore next */
ProductList.install = function (Vue) {
  Vue.component(ProductList.name, ProductList);
};

export default ProductList;
